@if (isVisible && isMobile && !isNativeApp) {
<div class="app-referrer" [@slideAnimation] role="banner" aria-label="E|Forsyning app reklame">
    <div class="app-referrer__container">
        <div class="app-referrer__info">
            <button class="app-referrer__close" (click)="close()" aria-label="Luk app-promovering" type="button">✕</button>
            <img class="app-referrer__icon" src="/dist/e-forsyning/assets/icon.png" alt="E|Forsyning app ikon" width="48" height="48" />
            <div class="app-referrer__content">
                <h2 class="app-referrer__title">Hent E|Forsyning appen</h2>
                <p class="app-referrer__subtitle">Få adgang til alle funktioner direkte i appen</p>
            </div>
        </div>
        <button class="app-referrer__open-app" (click)="openApp()" aria-label="Åben E|Forsyning app eller gå til app store" type="button">Åben</button>
    </div>
</div>
}
